import styled from "styled-components";

export const GlobalDefault = styled.div`
  text-align: center;
  background: #100536;
  min-height: 100vh;
  padding-bottom: 3rem;
  transition: 350ms;
`;
